/** Network operstate / adapter status helpers (Linux: UP, Windows: Up). */

export function isNetworkUp(status) {
  if (status == null || status === '') return true;
  return String(status).trim().toLowerCase() === 'up';
}

export function isNetworkDown(status) {
  if (status == null || status === '') return false;
  const s = String(status).trim().toLowerCase();
  return (
    s === 'down'
    || s === 'disconnected'
    || s === 'notpresent'
    || s === 'lowerlayerdown'
    || s.includes('disconnect')
  );
}

export function buildHardwareSummary(hwData) {
  if (!hwData) {
    return { overall: 'Healthy', issues: [], checked_at: null };
  }

  const issues = [];

  (hwData.disks || []).forEach((d) => {
    if (d.health && d.health !== 'Healthy' && d.health !== 'OK' && d.health !== 'Unknown') {
      issues.push({ type: 'disk', severity: 'critical', message: `Disk "${d.name}" health: ${d.health}` });
    }
  });

  if (hwData.battery) {
    if (hwData.battery.health === 'Critical') {
      issues.push({
        type: 'battery',
        severity: 'critical',
        message: `Battery critically low: ${hwData.battery.charge_percent}%`,
      });
    } else if (hwData.battery.health === 'Low') {
      issues.push({
        type: 'battery',
        severity: 'warning',
        message: `Battery low: ${hwData.battery.charge_percent}%`,
      });
    }
  }

  if (hwData.temperature) {
    if (hwData.temperature.status === 'Critical') {
      issues.push({
        type: 'temperature',
        severity: 'critical',
        message: `Temperature critical: ${hwData.temperature.max_celsius}°C`,
      });
    } else if (hwData.temperature.status === 'Warning') {
      issues.push({
        type: 'temperature',
        severity: 'warning',
        message: `Temperature high: ${hwData.temperature.max_celsius}°C`,
      });
    }
  }

  (hwData.network || []).forEach((n) => {
    if (isNetworkDown(n.status)) {
      issues.push({
        type: 'network',
        severity: 'warning',
        message: `Network "${n.name}": ${n.status}`,
      });
    }
  });

  const overall = issues.some((i) => i.severity === 'critical')
    ? 'Critical'
    : issues.some((i) => i.severity === 'warning')
      ? 'Warning'
      : 'Healthy';

  return {
    overall,
    issues,
    checked_at: hwData.summary?.checked_at || new Date().toISOString(),
  };
}
